export default __webpack_public_path__ + "static/wct-logo-a9cc5c16e5b026b45406969531963472.svg";